import { BRIEF_AI_CONFIG_QUERY_KEY } from "@entities/ai/lib/constants";
import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBrief } from "@shared/lib/types/brief";
import { BriefService } from "../services/brief.service";

export function useUpdateBrief() {
  const {
    mutate: updateBrief,
    isLoading: isUpdating,
    isSuccess: isUpdated,
    variables,
  } = useMutation({
    mutationFn: ({ updatedBrief }: { updatedBrief: Partial<IBrief> }) =>
      BriefService.updateBrief(updatedBrief).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, _, data) => {
      ToastService.success("Brief Updated Successfully");
      c.invalidateQueries({ queryKey: BRIEF_LIST_QUERY_KEY });
        c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, data.updatedBrief._id],
        });

        c.invalidateQueries({
          queryKey: BRIEF_AI_CONFIG_QUERY_KEY(
          data.updatedBrief._id || "",
          data.updatedBrief.brandId || ""
          ),
        });
    },
  });
  return {
    updateBrief,
    isUpdating,
    isUpdated,
    variables,
  };
}
